export const isNonEmpty = (array) => {
    return Array.isArray(array) && array.length > 0;
};
